module.exports = __webpack_public_path__ + "img/ico-collapse.a9ebc9d5.svg";